import externalLinks from "../../../constants/externalLinks";
import {getSignInUrl, getSignUpUrl} from "../../../helpers/routingHelpers";
import FooterItem from "../FooterItem";
import FooterSection from "../FooterSection";
import {useUser} from "../../../features/user/hooks";

const FooterAccountSection = ({className = ""}) => {
  const user = useUser();

  return (
    <FooterSection titleId="footer.account" className={className}>
      {user ? (
        <>
          <FooterItem
            messageId="menu.watchlist"
            href={externalLinks.watchlist}
          />
          <FooterItem
            messageId="menu.crunchylists"
            href={externalLinks.crunchylists}
          />
          <FooterItem messageId="menu.history" href={externalLinks.history} />
          <FooterItem messageId="menu.account" href={externalLinks.myAccount} />
          <FooterItem
            messageId="menu.log_out_title"
            href={externalLinks.logout}
          />
        </>
      ) : (
        <>
          <FooterItem messageId="menu.signup_title" href={getSignUpUrl()} />
          <FooterItem messageId="menu.signin_title" href={getSignInUrl()} />
        </>
      )}
    </FooterSection>
  );
};

export default FooterAccountSection;
